import api from '../../utils/api'

export const state = {}

export const mutations = {}

export const actions = {
  async handleCreate(_, body) {
    try {
      return await api.post('/tag-email-automation', body)
    } catch (e) {

    }
  },

  async handleUpdate(_, body) {
    try {
      return await api.put(`/tag-email-automation/${body._id}`, body)
    } catch (e) {

    }
  },

  async handleGet(_, _id) {
    try {
      return await api.get(`/tag-email-automation/${_id}`)
    } catch (e) {

    }
  },

  async handlePagedList(_, payload) {
    try {

      const params = new URLSearchParams()
      if (payload.page) {
        params.set('page', payload.page)
      }
      if (payload.limit) {
        params.set('limit', payload.limit)
      }
      if (payload.triggerTags) {
        params.set('triggerTags', payload.triggerTags)
      }
      const { data: response } = await api.get(`/tag-email-automation?${params.toString()}`)
      return response
    } catch (e) {

    }
  },

  async handleDelete(_, _id) {
    try {
      return await api.delete(`/tag-email-automation/${_id}`)
    } catch (e) {

    }
  },

  async handleSendInBatch(_, body) {
    try {
      return await api.post(`/tag-email-automation/send-batch`, body)
    } catch (e) {

    }
  }
}

export const getters = {}
